import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Mail, MessageCircle, ArrowLeft, Send, CheckCircle } from "lucide-react";

export default function ContactUs() {
  const [form, setForm] = useState({ name: "", email: "", subject: "", message: "" });
  const [sent, setSent] = useState(false);

  function handleSubmit(e) {
    e.preventDefault();
    const body = `Name: ${form.name}%0AEmail: ${form.email}%0ASubject: ${form.subject}%0A%0AMessage:%0A${form.message}`;
    window.location.href = `mailto:campusswap.official@gmail.com?subject=${encodeURIComponent(form.subject || "CampusSwap Support")}&body=${body}`;
    setSent(true);
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-600 via-blue-700 to-blue-900 px-4 py-8">
      <div className="max-w-sm mx-auto">

        {/* Back */}
        <Link to="/about" className="inline-flex items-center gap-1.5 text-blue-200 text-sm mb-6 hover:text-white">
          <ArrowLeft size={16} /> Back
        </Link>

        {/* Header */}
        <div className="text-center mb-6">
          <h1 className="text-3xl font-bold text-white">Contact Us</h1>
          <p className="text-blue-200 text-sm mt-1">We're here to help — reach us anytime</p>
        </div>

        {/* Quick contact cards */}
        <div className="space-y-3 mb-6">
          <a href="mailto:campusswap.official@gmail.com"
            className="flex items-center gap-3 bg-white/10 backdrop-blur rounded-2xl p-4 hover:bg-white/20 transition-colors">
            <div className="w-10 h-10 bg-blue-500 rounded-xl flex items-center justify-center flex-shrink-0">
              <Mail size={20} className="text-white" />
            </div>
            <div>
              <p className="text-white font-semibold text-sm">Email</p>
              <p className="text-blue-200 text-xs">campusswap.official@gmail.com</p>
            </div>
          </a>

          <a href="https://wa.me/918999325996" target="_blank" rel="noreferrer"
            className="flex items-center gap-3 bg-white/10 backdrop-blur rounded-2xl p-4 hover:bg-white/20 transition-colors">
            <div className="w-10 h-10 bg-green-500 rounded-xl flex items-center justify-center flex-shrink-0">
              <MessageCircle size={20} className="text-white" />
            </div>
            <div>
              <p className="text-white font-semibold text-sm">WhatsApp</p>
              <p className="text-blue-200 text-xs">Chat with us for quick help</p>
            </div>
          </a>

          <a href="https://instagram.com/campusswap_in" target="_blank" rel="noreferrer"
            className="flex items-center gap-3 bg-white/10 backdrop-blur rounded-2xl p-4 hover:bg-white/20 transition-colors">
            <div className="w-10 h-10 bg-pink-500 rounded-xl flex items-center justify-center flex-shrink-0">
              <span className="text-white text-lg">📸</span>
            </div>
            <div>
              <p className="text-white font-semibold text-sm">Instagram</p>
              <p className="text-blue-200 text-xs">@campusswap_in</p>
            </div>
          </a>
        </div>

        {/* Contact form */}
        <div className="bg-white rounded-2xl p-5 shadow-xl">
          <h2 className="font-bold text-gray-800 mb-4">Send us a message</h2>
          {sent ? (
            <div className="text-center py-6">
              <CheckCircle size={48} className="text-green-500 mx-auto mb-3" />
              <p className="font-semibold text-gray-800">Opening your email app...</p>
              <p className="text-sm text-gray-500 mt-1">Your message is pre-filled. Just hit send!</p>
              <button onClick={() => setSent(false)} className="mt-4 text-blue-600 text-sm hover:underline">
                Send another message
              </button>
            </div>
          ) : (
            <form onSubmit={handleSubmit} className="space-y-3">
              <div>
                <label className="block text-xs font-medium text-gray-600 mb-1">Your Name</label>
                <input type="text" value={form.name} onChange={e => setForm(f => ({ ...f, name: e.target.value }))}
                  placeholder="Full name" required
                  className="w-full px-3 py-2.5 border border-gray-200 rounded-xl text-sm focus:ring-2 focus:ring-blue-500 focus:border-transparent" />
              </div>
              <div>
                <label className="block text-xs font-medium text-gray-600 mb-1">Your Email</label>
                <input type="email" value={form.email} onChange={e => setForm(f => ({ ...f, email: e.target.value }))}
                  placeholder="your@email.com" required
                  className="w-full px-3 py-2.5 border border-gray-200 rounded-xl text-sm focus:ring-2 focus:ring-blue-500 focus:border-transparent" />
              </div>
              <div>
                <label className="block text-xs font-medium text-gray-600 mb-1">Subject</label>
                <select value={form.subject} onChange={e => setForm(f => ({ ...f, subject: e.target.value }))} required
                  className="w-full px-3 py-2.5 border border-gray-200 rounded-xl text-sm focus:ring-2 focus:ring-blue-500 focus:border-transparent bg-white">
                  <option value="">Select a topic</option>
                  <option>Account issue</option>
                  <option>Listing problem</option>
                  <option>Report a user</option>
                  <option>Verification help</option>
                  <option>Feature suggestion</option>
                  <option>Other</option>
                </select>
              </div>
              <div>
                <label className="block text-xs font-medium text-gray-600 mb-1">Message</label>
                <textarea value={form.message} onChange={e => setForm(f => ({ ...f, message: e.target.value }))}
                  placeholder="Describe your issue or question..." required rows={4}
                  className="w-full px-3 py-2.5 border border-gray-200 rounded-xl text-sm focus:ring-2 focus:ring-blue-500 focus:border-transparent resize-none" />
              </div>
              <button type="submit"
                className="w-full bg-blue-600 text-white py-3 rounded-xl font-semibold text-sm hover:bg-blue-700 flex items-center justify-center gap-2">
                <Send size={15} /> Send Message
              </button>
            </form>
          )}
        </div>

        <p className="text-center text-blue-300 text-xs mt-5">
          We typically respond within 24 hours.
        </p>
      </div>
    </div>
  );
}
